<div class="login-container">
  <!-- Left Panel (Illustration & Branding for Desktop/Tablets) -->
  <div class="left-panel">
    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
      <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
      <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
      <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
    </div>

    <div class="left-panel-text">
      {{ isMr
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>

    <div class="left-panel-image-wrap">
      <img src="assets/dashboard icons/AshaPic.png" alt="Asha" class="left-hero-img" />
    </div>
  </div>

  <!-- Right Panel (New Password Form) -->
  <div class="right-container">
    <div class="login-card-wrapper">
      <!-- Mobile logos strip shown when left panel is hidden -->
      <div class="mobile-logos-bar">
        <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
        <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
        <img class="mobile-center-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
        <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
        <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
      </div>

      <div class="login-card">
        <div class="login-header-icon-wrap">
          <img class="login-header-icon" src="assets/icons/headericon_pink.png" alt="Asha" />
        </div>

        <h2 class="login-title">
          {{ isMr ? 'नवीन पासवर्ड तयार करा' : 'Create New Password' }}
        </h2>

        <p class="login-subtitle">
          {{ isMr
          ? 'तुमच्या खात्यासाठी नवीन पासवर्ड तयार करा'
          : 'Create new password for your account' }}
        </p>

        <form class="login-form" (submit)="onSubmit()">
          <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
            [showColonAfterLabel]="false">

            <dxi-form-item dataField="password" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: isMr ? 'नवीन पासवर्ड टाका' : 'Enter your password',
                mode: passwordMode,
                buttons: [{
                  name: 'togglePassword',
                  id:'password',
                  value: formData.password,
                  location: 'after',
                  options: {
                    icon: passwordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                    onClick: togglePasswordVisibility
                  }
                }]
              }">
              <dxo-label [text]="isMr ? 'नवीन पासवर्ड' : 'New Password'"></dxo-label>
            </dxi-form-item>

            <dxi-form-item dataField="confirmpassword" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: isMr ? 'पासवर्डची पुष्टी करा' : 'Enter Confirm Password',
                mode: confirmpasswordMode,
                buttons: [{
                  name: 'togglePassword',
                  id:'confirmpassword',
                  value: formData.confirmpassword,
                  location: 'after',
                  options: {
                    icon: confirmpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                    onClick: toggleConfirmPasswordVisibility
                  }
                }]
              }">
              <dxo-label [text]="isMr ? 'पासवर्डची पुष्टी' : 'Confirm Password'"></dxo-label>
            </dxi-form-item>
          </dx-form>

          <div class="login-action-wrap">
            <dx-button [text]="isMr ? 'जतन करा' : 'Save'" type="default" stylingMode="contained" class="login-button"
              (click)="onSubmit()"></dx-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>